import EDITIONS from "./editions";

export const ROUTES = [
    { id: 1, path: '/honduras', description: "Honduras", edition: EDITIONS.HONDURAS },
    { id: 2, path: '/bogota', description: "Bogota", edition: EDITIONS.BOGOTA },
    { id: 3, path: '/buenos-aires', description: "Buenos Aires", edition: EDITIONS.BUENOSAIRES }
]